import XFetch from "../../common/x-fetch"
import Actions from '../actions'
import SystemActions from "../system/system-actions"
import { batch } from "react-redux"

function loadGame (gameId) {
  //console.log(`load game ${gameId}`)
  return (dispatch) => {
    XFetch.post(`/api/load_game_state`, {'game_id': gameId})
    .then(result => {
      batch(() => {
        window.location.hash = result?.data?.game_state?._id
        dispatch({
          type: Actions.GAME_SET_GAME,
          payload: result.data.game_state,
        })
        dispatch({
          type: Actions.UI_SET_ACTIVE_PAGE,
          payload: 'GAME', // // should be UIActions.enums.pageNames.GAME but I'm not quite sure where to put the enums
        })
      })
    })
    .catch(err => {
      dispatch(SystemActions.handleUserFacingMessages(err))
    })
  }
}

function submitMove (action) {
  return (dispatch, getState) => {
    dispatch({
      type: Actions.GAME_SET_IS_SUBMITTING,
      payload: true,
    })
    
    const state = getState()
    let postPayload = {
      game_id: state.game.gameState._id,
      action: action,
    }

    XFetch.post(`/api/submit_move`, postPayload)
    .then(result => {
      console.log(result)
      dispatch({
        type: Actions.GAME_SET_IS_SUBMITTING,
        payload: false,
      })
      // dispatch({
      //   type: Actions.SYSTEM_SET_SYSTEM_MESSAGE,
      //   payload: result.data.message,
      // })
      dispatch(SystemActions.handleUserFacingMessages(result))
      //if (!result.data.message.success) {
        // TODO: show fail in the reader board
      //}
    })
    .catch(err => {
      dispatch({
        type: Actions.GAME_SET_IS_SUBMITTING,
        payload: false,
      })
      // dispatch({
      //   type: Actions.SYSTEM_SET_SYSTEM_MESSAGE,
      //   payload: {
      //     success: false,
      //     message: [err],
      //   },
      // })

      dispatch(SystemActions.handleUserFacingMessages(err))
    })
  }
}

function updateGame (gameUpdate) {
  return {
    type: Actions.GAME_UPDATE,
    payload: gameUpdate,
  }
}

function setFinal (gameUpdate) {
  return {
    type: Actions.GAME_SET_FINAL,
    payload: gameUpdate
  }
}

function playerMoved (payload) {
  console.log(payload)
  return {
    type: Actions.GAME_ADD_SUBMITTED_PLAYER,
    payload
  }
}

export default {
  loadGame,
  submitMove,
  updateGame,
  setFinal,
  playerMoved,
}
